var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AmeliproErrorTemplate',{attrs:{"error-type":_vm.pageInfo.template,"custom-content-text":_vm.pageInfo.message,"custom-content-title":_vm.pageInfo.title,"no-button":Boolean(_vm.pageInfo.noButton),"btn-href":"/login"}})
}
var staticRenderFns = []

export { render, staticRenderFns }